module.exports = __webpack_public_path__ + "img/issue-icon7.382647f.png";